import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import { MentionList } from '../MentionList';

type Variable = { id: string; label: string };

/**
 * Builds the TipTap Mention `suggestion` config that renders the variable
 * picker popup (triggered by typing `@`).
 */
export function createMentionSuggestion(variables: Variable[]) {
    return {
        char: '@',
        items: ({ query }: { query: string }) => {
            return variables
                .filter(item => item.label.toLowerCase().includes(query.toLowerCase()))
                .slice(0, 8);
        },
        render: () => {
            let reactRenderer: any;
            let popup: any;

            return {
                onStart: (props: any) => {
                    reactRenderer = new ReactRenderer(MentionList, {
                        props: {
                            ...props,
                            allItems: variables,
                            hasQuery: Boolean(props.query),
                        },
                        editor: props.editor,
                    });

                    if (!props.clientRect) return;

                    popup = tippy('body', {
                        getReferenceClientRect: props.clientRect,
                        appendTo: () => document.body,
                        content: reactRenderer.element,
                        showOnCreate: true,
                        interactive: true,
                        trigger: 'manual',
                        placement: 'bottom-start',
                    });
                },
                onUpdate(props: any) {
                    reactRenderer?.updateProps({
                        ...props,
                        allItems: variables,
                        hasQuery: Boolean(props.query),
                    });
                    if (!props.clientRect) return;
                    popup?.[0]?.setProps({
                        getReferenceClientRect: props.clientRect,
                    });
                },
                onKeyDown(props: any) {
                    if (props.event.key === 'Escape') {
                        popup?.[0]?.hide();
                        return true;
                    }
                    return reactRenderer?.ref?.onKeyDown(props) ?? false;
                },
                onExit() {
                    popup?.[0]?.destroy();
                    reactRenderer?.destroy();
                },
            };
        },
    };
}
